import React, { useEffect } from "react";
import "./creditMemoReport.css";
import CreditMemoReportHeader from "./CreditMemoReportHeader/CreditMemoReportHeader";
import { useDispatch, useSelector } from "react-redux";
import { getCreditMemoReportPrint } from "../../redux/actions/creditMemoReport.action";
import { Button } from "antd";
import { useLocation } from "react-router-dom";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";
import { currencySymbol } from "../../utils/constants";
import Loader from "react-loader-spinner";

const CreditMemoReport = ({ token }) => {
  TabTitle("Credit Memo Report")
  const dispatch = useDispatch();
  const { creditMemoReportPrint } = useSelector((state) => state);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();

  let note_header_id = query.get("note_header_id");

  const data = creditMemoReportPrint && creditMemoReportPrint?.payload?.data;

  const values = {

    note_header_id: note_header_id,
  };

  useEffect(() => {
    dispatch(getCreditMemoReportPrint(token, values));
  }, []);

  let sumAmount = creditMemoReportPrint?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(currentValue.amount));
  },
    0);

  let sumDiscount = creditMemoReportPrint?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(currentValue.discount));
  },
    0);

  const totalQuantity = data && data.length ? data.reduce((total, x) => total + Number(x.quantity), 0) : 0

  const handlePrint = () => {
    const css = '@page { size: portrait; margin: 2mm 10mm !important;  }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  if (creditMemoReportPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  return (
    <div className="__credit_memo_report"    >
      <table width="100%">
        <thead>
          <tr>
            <td>
              <CreditMemoReportHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body data={data} sumAmount={sumAmount} sumDiscount={sumDiscount} totalQuantity={totalQuantity} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CreditMemoReport;

const Body = ({ data, sumAmount, sumDiscount, totalQuantity }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          <table width="100%">
            <tbody>
              <tr>
                <th
                  style={{
                    width: "88px",
                  }}
                >
                  Quantity
                </th>
                <th
                  className="__item_ss"
                >
                  Item
                </th>
                <th
                  style={{
                    width: "50%",
                  }}
                >
                  Description
                </th>
                <th
                  style={{
                    width: "110px",
                    textAlign: 'right'
                  }}
                >
                  Rate
                </th>
                <th
                  style={{
                    width: "110px",
                    textAlign: 'right'
                  }}
                >
                  Discount
                </th>
                <th
                  style={{
                    width: "110px",
                    textAlign: 'right',
                    whiteSpace: "nowrap"
                  }}
                >
                  Tax Amount
                </th>
                <th
                  style={{
                    width: "110px",
                    textAlign: 'right'
                  }}
                >
                  Amount
                </th>
              </tr>
              {data?.map((it, index) => {
                return (
                  <tr key={index}>
                    <td>{numeral(it.quantity).format("0")}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {it.sku}
                    </td>
                    <td>
                      {it?.description && it?.description}
                    </td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>{currencySymbol}{it.rate && it.rate}</td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>
                      {currencySymbol}{it.discount && it.discount}
                    </td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>
                      {currencySymbol}{it.tax_amount && it.tax_amount}
                    </td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>{currencySymbol}{it.amount && Number(it.amount).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <hr style={{ marginBottom: 0 }} />
      <span style={{ paddingLeft: "5px", fontSize: "10px" }}>{totalQuantity}</span>
      <hr style={{ marginTop: "2px" }} />
      <div className="__summary_box">
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td width="270px">
                <table width="100%" className="__summary_box_table">
                  <tbody>
                    <tr>
                      <td>
                        Total
                      </td>
                      <td></td>
                      <td>
                        {currencySymbol}{sumAmount && numeral(data[0]?.total_gross_amount).format("00.00")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Less Discount
                      </td>
                      <td></td>
                      <td>{currencySymbol}{data && numeral(sumDiscount).format("0.00")}</td>
                    </tr>
                    <tr>
                      <td>
                        Re-Stocking fee
                      </td>
                      <td></td>
                      <td>{currencySymbol}{data && numeral(data[0].re_stock).format("0.00")}</td>
                    </tr>
                    <tr>
                      <td>
                        Return Label Fee
                      </td>
                      <td></td>
                      <td>{currencySymbol}{data && numeral(data[0].return_label_fee).format("0.00")}</td>
                    </tr>

                    <tr>
                      <td>
                        Add Tax
                      </td>
                      <td>{data && data[0].tax_percent}%</td>
                      <td>{currencySymbol}{data && numeral(data[0].total_tax_amount).format("0.00")}</td>
                    </tr>
                    <tr>
                      <td>
                        Net Total
                      </td>
                      <td></td>
                      <td>{currencySymbol}{data && numeral((sumAmount) - (data[0].re_stock || 0) - (data[0].return_label_fee || 0)).format("00.00")}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
